import Token from "src/util/Token";

export const CMS_ENDPOINT = `${process.env.REACT_APP_CSMS_API_ENDPOINT}/cms`;
export const CMS_ENDPOINT_V1 = `${CMS_ENDPOINT}/v1`;
export const CMS_ENDPOINT_V2 = `${CMS_ENDPOINT}/v2`;
export const loginUrl = `${process.env.REACT_APP_CSMS_API_ENDPOINT}/auth/login`;
export const resetUrl = `${process.env.REACT_APP_CSMS_API_ENDPOINT}/auth/resetpwdrequest`;
export const verificationAndResetUrl = `${process.env.REACT_APP_CSMS_API_ENDPOINT}/auth/resetpwd`;
export const changePasswordUrl = `${process.env.REACT_APP_CSMS_API_ENDPOINT}/auth/changepwd`;
export const PORTAL_ENDPOINT = `${process.env.REACT_APP_PORTAL_API_LINK}`;
const setupUrl = `${CMS_ENDPOINT_V1}/setup`;
export const userUrl = `${CMS_ENDPOINT_V1}/profile`;
export const usersUrl = `${CMS_ENDPOINT_V1}/users`;
export const rolesUrl = `${CMS_ENDPOINT_V1}/roles`;
export const roleUrl = `${CMS_ENDPOINT_V1}/role`;
export const getRoleUrlId = (id) => `${roleUrl}/${id}`;
export const getRoleUsersUrl = (id) => `${roleUrl}/${id}/users`;
export const getRoleAssignedCompaniesUrl = (id) => `${roleUrl}/${id}/companies`;
export const roleUserUrl = (id) => `${roleUrl}/${id}/user`;
export const roleCompaniesUrl = `${rolesUrl}/companies`;
export const categoryUrl = `${setupUrl}/category`;
export const userTypeUrl = `${setupUrl}/usertype`;
export const chargersUrl = `/chargers`;
export const chargerUrl = `/charger`;
export const chargerIdUrl = (chargerId) => `${chargerUrl}/${chargerId}`;
export const tagsUrl = `/tags`;
export const parentTagsUrl = `/parenttags`;
export const tagsForRemoteOpUrl = `/tags/remoteop`;
export const availableTagsUrl = `/availabletags`;
export const tagUrl = `/tag`;
export const tagIdUrl = (tagId) => `${tagUrl}/${tagId}`;
export const tagRollupUrl = (tagId) => `${tagIdUrl(tagId)}/rollup`;
export const tagChildrenUrl = (tagId) => `${tagIdUrl(tagId)}/children`;
export const tagParentTransactionsUrl = (tagId) =>
  `${tagIdUrl(tagId)}/parent-transactions`;
export const tagChargerUrl = (tagId, chargerId = null) =>
  `${tagIdUrl(tagId)}/chargers${chargerId ? "/" + chargerId : ""}`;
export const tagUserUrl = (teamId, tagId) =>
  `${getTeamUrl(teamId, tagIdUrl(tagId))}/users`;
export const priceGroupsUrl = `/pricegroups`;
export const priceGroupUrl = `/pricegroup`;
export const priceGroupIdUrl = (priceGroupId) =>
  `${priceGroupUrl}/${priceGroupId}`;
export const transaction = `${CMS_ENDPOINT_V1}/company`;
export const transactionsUrl = `/transactions`;
export const exportTransactionsUrl = `/transactions/export-to-excel`;
export const transactionUrl = "/transaction";
export const refundUrl = `${CMS_ENDPOINT_V1}/refund`;
export const chargerTransactions = (id) => `/charger/${id}/transactions`;
export const chargerActiveTransactions = (id) =>
  `/charger/${id}/transactions/active`;
export const tagTransactions = (id) => `/tag/${id}/transactions`;
export const transactionIdUrl = (transactionId) =>
  `${transactionUrl}/${transactionId}`;
export const meterValueUrl = (url, connectorId) =>
  `${url}/meter_value/${connectorId}`;
export const teamsUrl = (parentTeamId) =>
  `${CMS_ENDPOINT_V1}/teams/${parentTeamId}`;
export const teamUrl = `${CMS_ENDPOINT_V1}/team`;
export const teamUrlId = (id) => `${teamUrl}/${id}`;
export const teamUsersUrl = `/users`;
export const getTeamUrl = (teamId, url, id) => {
  if (id) return `${CMS_ENDPOINT_V1}/team/${teamId}${url}/${id}`;
  return `${CMS_ENDPOINT_V1}/team/${teamId}${url}`;
};
export const getSettlementPercentageUrl = `${CMS_ENDPOINT_V1}/team/settlementpercentage`;
export const getPaymentDetailsForPriceGroupUrl = (teamId) =>
  `${CMS_ENDPOINT_V1}/team/${teamId}/paymentDetails`;
export const getPaymentDetailsOfCompany = (companyId) =>
  `${CMS_ENDPOINT_V1}/company/${companyId}/paymentDetails`;
export const getUserDetailUrl = (id) => `${CMS_ENDPOINT_V1}/user/${id}`;
export const getUserStatusUrl = (id) =>
  `${CMS_ENDPOINT_V1}/user/${id}/status`;
export const addUserUrl = `${CMS_ENDPOINT_V1}/user`;
export const getUserRoleUrl = (id) => `${CMS_ENDPOINT_V1}/user/${id}/role`;
export const getUserIdUrl = (userId) => `/user/${userId}`;
export const getUserProfile = () => `${CMS_ENDPOINT_V1}/profile`;
// export const companyUrl = `/cms/v1/company`; // OLD V1 VERSION
export const companyUrl = `/cms/v2/company`;
// OCPI partners that exist only in ocpi_company_details have no companyId, so the list
// gives them an "ocpi-<ocpi_company_details_pk>" id which maps to a dedicated route.
export const OCPI_ONLY_COMPANY_ID_PREFIX = "ocpi-";
export const isOcpiOnlyCompanyId = (id) =>
  typeof id === "string" && id.startsWith(OCPI_ONLY_COMPANY_ID_PREFIX);
export const getCompanyUrlId = (id) =>
  isOcpiOnlyCompanyId(id)
    ? `${companyUrl}/ocpi/${id.slice(OCPI_ONLY_COMPANY_ID_PREFIX.length)}`
    : `${companyUrl}/${id}`;
export const getCompanyPublishedChargersUrl = (id) =>
  `${getCompanyUrlId(id)}/publishedChargers`;
export const featureUrl = `${CMS_ENDPOINT_V1}/feature`;
export const remoteOperationUrl = `${CMS_ENDPOINT_V1}/remote/operation`;
export const remoteOperationTaskUrl = (chargerId, taskId) =>
  `${CMS_ENDPOINT_V1}/remote/operation/charger/${chargerId}/task/${taskId}`;
export const viewLogsUrl = (id) => `${chargerIdUrl(id)}/logs`;
export const logsCountUrl = (id) => `${chargerIdUrl(id)}/log/count`;
export const getConnectorsUrl = (id) => `${chargerIdUrl(id)}/connectors`;
export const getTagsByChargerIdUrl = (chargerId) =>
  `${chargerIdUrl(chargerId)}/tags`;
export const customerUrl = `${CMS_ENDPOINT_V1}/customer`;
export const cmCustomerUrl = `${CMS_ENDPOINT_V1}/root/customer`;
export const getCustomerById = (id) => `${customerUrl}/${id}`;
export const customerTagsById = (id, userTagId) =>
  !userTagId
    ? `${customerUrl}/${id}/tags`
    : `${customerUrl}/${id}/tags/${userTagId}`;
export const uploadImgUrl = `${PORTAL_ENDPOINT}/util/image-upload`;
export const serviceRequestUrl = `${CMS_ENDPOINT_V1}/support`;
export const getServiceRequestDetailsUrl = (id) => `${serviceRequestUrl}/${id}`;
export const chargingProfileListUrl = () =>
  `${CMS_ENDPOINT_V1}/charging-profile`;
export const chargingProfileDetailsUrl = (chargingProfileId) =>
  `${chargingProfileListUrl()}/${chargingProfileId}`;
export const apiKeysUrl = `${CMS_ENDPOINT_V1}/api-keys`;
export const apiKeyByIdUrl = (keyId) => `${apiKeysUrl}/${keyId}`;
export const paymentGatewayUrl = `/cms/v2/paymentgateway`;
export const availablePaymentGatewayListUrl = `${paymentGatewayUrl}`;
export const paymentGatewayDetailsUrl = `${paymentGatewayUrl}/details`;
// Provider lookup (cms_payment_gateway) behind the gateway picker on the form.
export const paymentGatewayMasterListUrl = `${paymentGatewayUrl}/gateways`;
export const paymentGatewayDetailsBulkUrl = `${paymentGatewayDetailsUrl}/bulk`;
// Charger-scoped lookup of the UPI URL configured for a connector name (key_id)
export const connectorUpiUrl = (teamId, chargerId, keyId) =>
  `${getTeamUrl(
    teamId,
    `/charger/${chargerId}/connector-upi`
  )}?key_id=${encodeURIComponent(keyId)}`;
export const paymentGatewayDetailByIdUrl = (id) =>
  `${paymentGatewayDetailsUrl}/${id}`;
export const paymentGatewayTransactionsUrl = (id) =>
  `${paymentGatewayDetailsUrl}/${id}/transactions`;
export const paymentGatewayTransactionStatusUrl = (id, orderId) =>
  `${paymentGatewayDetailsUrl}/${id}/transactions/${encodeURIComponent(
    orderId
  )}/status`;
export const paymentGatewayTransactionRefundUrl = (id, orderId) =>
  `${paymentGatewayDetailsUrl}/${id}/transactions/${encodeURIComponent(
    orderId
  )}/refund`;

// Audit log (Grand Parent / super admin only)
export const auditLogsUrl = `${CMS_ENDPOINT_V1}/audit-logs`;
export const auditAnalyticsUrl = `${auditLogsUrl}/analytics`;
export const auditUsersUrl = `${auditLogsUrl}/users`;
export const auditApiBreakdownUrl = `${auditLogsUrl}/api-breakdown`;
// export const paymentGateway =(paymentGatewayId)=> `${paymentGatewayUrl}/${paymentGatewayId}`
export const logFilterData = (
  teamId,
  chargerId,
  startDate,
  endDate,
  timeStart,
  timeEnd
) => {
  return `${CMS_ENDPOINT_V1}/team/${teamId}/charger/${chargerId}/log/time_interval?startDate=${startDate}&endDate=${endDate}&startTime=${timeStart}&endTime=${timeEnd}`;
};
export const reportTabData = (teamId, startDate, endDate) => {
  return `${CMS_ENDPOINT_V1}/team/${teamId}/report?startDate=${startDate}&endDate=${endDate}`;
};
export const getAvailableCharger = (teamId) => {
  return `${CMS_ENDPOINT_V2}/charging-site/${teamId}/available-chargers`;
};
export const getTeamChargerIds = (teamId, unassignedOnly = true) => {
  return `${CMS_ENDPOINT_V2}/charger/team/${teamId}/charger-ids?unassignedOnly=${unassignedOnly}`;
};
export const getChargingSiteList = (teamId) => {
  return `${CMS_ENDPOINT_V2}/charging-site/${teamId}/zone`;
};
export const getChargingSiteZoneNames = (teamId) => {
  return `${CMS_ENDPOINT_V2}/charging-site/${teamId}/zone-names`;
};
export const deleteChargingSiteById = (teamId, zoneId) => {
  return `${CMS_ENDPOINT_V2}/charging-site/${teamId}/zone/${zoneId}`;
};
export const updateChargingSiteById = (teamId, zoneId) => {
  return `${CMS_ENDPOINT_V2}/charging-site/${teamId}/zone/${zoneId}`;
};
export const getChargingSiteById = (teamId, zoneId) => {
  return `${CMS_ENDPOINT_V2}/charging-site/${teamId}/zone/${zoneId}`;
};
export const createChargingSite = (teamId) => {
  return `${CMS_ENDPOINT_V2}/charging-site/${teamId}/zone`;
};
export const getChargingSiteChargers = (teamId, zoneId) => {
  return `${CMS_ENDPOINT_V2}/charging-site/${teamId}/zone/${zoneId}/chargers`;
};
export const getChargingSiteChargerById = (teamId, zoneId, chargerId) => {
  return `${CMS_ENDPOINT_V2}/charging-site/${teamId}/zone/${zoneId}/chargers/${chargerId}`;
};
export const customerWalletUrl = (customerId) => {
  return `${CMS_ENDPOINT_V1}/root/customer-wallet/${customerId}`;
};
export const walletHistoryUrl = (customerId) => {
  return `${CMS_ENDPOINT_V1}/root/customer-wallet/${customerId}`;
};
export const customerDetailUrl = (customerId) => {
  return `${CMS_ENDPOINT_V1}/root/customer/${customerId}`;
};
export const customerRfidUrl = () => {
  return `${CMS_ENDPOINT_V1}/root/customer/personal-tags`;
};
export const addCustomerRfidUrl = (tagId) => {
  return `${CMS_ENDPOINT_V1}/root/customer/personal-tags/${tagId}`;
};
export const deleteCustomerRfidUrl = (tagId) => {
  return `${CMS_ENDPOINT_V1}/root/customer/personal-tags/${tagId}`;
};
export const customerUpiIdUrl = () => {
  return `${CMS_ENDPOINT_V1}/root//customer/upi-ids`;
};
export const addUpiIdUrl = (upiId) => {
  return `${CMS_ENDPOINT_V1}/root/customer/upi-ids/${upiId}`;
};
export const deleteUpiIdUrl = (upiId) => {
  return `${CMS_ENDPOINT_V1}/root/customer/upi-ids/${upiId}`;
};
export const sendMessageUrl = () => {
  return `${CMS_ENDPOINT_V1}/root/send-bulk-notifications`;
};
export const teamPayoutUrl = (teamId) => {
  return `${CMS_ENDPOINT_V1}/team/${teamId}/payouts`;
};

export const getTeamsByCompanyId = (companyId) => {
  return `${CMS_ENDPOINT_V1}/team/${companyId}/teams`;
};

export const getTeamPayout = (teamId, year, month) => {
  return `${CMS_ENDPOINT_V1}/team/${teamId}/teamPayout/${year}/${String(
    month
  ).padStart(2, "0")}`;
};

export const getTeamPayoutReport = (teamId, year, month, chargerIds) => {
  const base = `${CMS_ENDPOINT_V1}/team/${teamId}/payout-report/${year}/${String(
    month
  ).padStart(2, "0")}`;
  return chargerIds && chargerIds.length
    ? `${base}?chargerIds=${chargerIds.join(",")}`
    : base;
};

// Super-admin only: Amik service-fee invoice ledger (save, list, edit no., mark paid).
export const serviceInvoicesUrl = `${CMS_ENDPOINT_V1}/service-invoices`;
export const serviceInvoiceByPeriodUrl = (teamId, year, month) =>
  `${CMS_ENDPOINT_V1}/service-invoices/team/${teamId}/${year}/${String(
    month
  ).padStart(2, "0")}`;
export const serviceInvoiceUrl = (id) =>
  `${CMS_ENDPOINT_V1}/service-invoices/${id}`;
export const serviceInvoicePaidUrl = (id) =>
  `${CMS_ENDPOINT_V1}/service-invoices/${id}/paid`;

// Super-admin only: freeze a month's payout, and override a charger's figures.
export const finalizePayoutUrl = (teamId, year, month) =>
  `${CMS_ENDPOINT_V1}/team/${teamId}/payout/finalize/${year}/${String(
    month
  ).padStart(2, "0")}`;

export const overridePayoutUrl = (teamId, year, month, chargepointPk) =>
  `${CMS_ENDPOINT_V1}/team/${teamId}/payout/${year}/${String(month).padStart(
    2,
    "0"
  )}/charger/${chargepointPk}/override`;

// Super-admin: email the payout now, and manage recurring/one-off email schedules.
export const emailPayoutUrl = (teamId, year, month) =>
  `${CMS_ENDPOINT_V1}/team/${teamId}/payout/${year}/${String(month).padStart(
    2,
    "0"
  )}/email`;
export const payoutEmailSchedulesUrl = (teamId) =>
  `${CMS_ENDPOINT_V1}/team/${teamId}/payout/email-schedules`;
export const payoutEmailScheduleUrl = (teamId, scheduleId) =>
  `${CMS_ENDPOINT_V1}/team/${teamId}/payout/email-schedules/${scheduleId}`;

export const upiTransactionsUrl = (teamId, dateRange = "today") => {
  return `${CMS_ENDPOINT_V1}/razorpay-transactions/razorpay/transactions?teamId=${teamId}&dateRange=${dateRange}`;
};

export const refundDetailsUrl = (teamId, paymentId) => {
  return `${CMS_ENDPOINT_V1}/razorpay-transactions/razorpay/refunds/payment/${paymentId}?teamId=${teamId}`;
};

export const paytmWebhookRefundUrl = `${CMS_ENDPOINT_V1}/paytm-webhook/refund`;

export const paytmRefundReceiptUrl = (paymentId) =>
  `${CMS_ENDPOINT_V1}/paytm/refund-receipt/${paymentId}`;

export const getVehicles = (id) => {
  return `${CMS_ENDPOINT_V1}/team/${id}/vehicles`;
};

export const getVehicleByTeamId = (teamId) => {
  return fetch(`${CMS_ENDPOINT_V1}/team/${teamId}/vehicles`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${Token.get()}`,
    },
  }).then((response) => response.json());
};

export const getVehicleByVehicleId = (teamId, vehicleId) => {
  return fetch(`${CMS_ENDPOINT_V1}/team/${teamId}/vehicles/${vehicleId}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${Token.get()}`,
    },
  }).then((response) => response.json());
};

export const addVehicleUrl = (id) => {
  return `${CMS_ENDPOINT_V1}/team/${id}/vehicles`;
};

export const updateVehicleUrl = (id, vehicleId) => {
  return `${CMS_ENDPOINT_V1}/team/${id}/vehicles/${vehicleId}`;
};

export const deleteVehicleUrl = (id, vehicleId) => {
  return `${CMS_ENDPOINT_V1}/team/${id}/vehicles/${vehicleId}`;
};

export const getAvailableVehicles = (id) => {
  return `${CMS_ENDPOINT_V1}/team/${id}/vehicles/availableVehicles`;
};

export const getAttachedVehicleToCustomer = (id) => {
  return `${CMS_ENDPOINT_V1}/customer/${id}/vehicle/attachedVehicle`;
};

export const assignVehicleToCustomer = (id) => {
  return `${CMS_ENDPOINT_V1}/customer/${id}/vehicle/assignVehicle`;
};

export const unassignVehicleToCustomer = (id) => {
  return `${CMS_ENDPOINT_V1}/customer/${id}/vehicle/unassignVehicle`;
};

export const getVehicleChargingHistory = (vin) => {
  return `${CMS_ENDPOINT_V1}/vin/${vin}/transactions`;
};

export const getVehicleEnergySummary = (vin) => {
  return `${CMS_ENDPOINT_V1}/vin/${vin}/energy`;
};
